export const translation = {
  "nav": {
    "home": "Accueil",
    "about": "A Propos",
    "vendors": "Vendeurs",
    "riders": "Livreurs",
    "waitlist": "Liste d'attente",
    "contact": "Contact"
  },
  "hero": {
    "headline": "Decouvrez et commandez chez vos restaurants, fast food et street food locaux preferes",
    "subheadline": "Connecter les clients, les restaurants, fast food, street food et les livreurs a moto a travers Douala et Yaounde.",
    "cta_waitlist": "Rejoindre la liste d'attente",
    "cta_vendor": "Devenir vendeur",
    "cta_rider": "Devenir livreur"
  },
  "problem": {
    "title": "Le Defi",
    "subtitle": "Pourquoi la livraison de nourriture ne fonctionne pas au Cameroun",
    "problem1_title": "Systemes d'adresse difficiles",
    "problem1_desc": "De nombreux quartiers manquent d'adresses formelles, ce qui rend la livraison un jeu de devoir frustrant.",
    "problem2_title": "Options de livraison limitees",
    "problem2_desc": "La plupart des applications de livraison se concentrent sur les grands restaurants, laissant les chop bars et le street food invisibles.",
    "problem3_title": "Services de livraison peu fiables",
    "problem3_desc": "Des temps d'attente longs, de la nourriture froide et un service inconsistent laissent les clients decus.",
    "problem4_title": "Aucune visibilite pour le street food, restaurants et fast food",
    "problem4_desc": "Les meilleurs repas sont souvent du street food qui restent caches au-dela de leur zone locale."
  },
  "solution": {
    "title": "Comment fonctionne Mayouk",
    "subtitle": "Simple, rapide et concu pour le Cameroun",
    "step1_title": "Passez votre commande",
    "step1_desc": "Parcourez les vendeurs locaux et commandez vos repas preferes via l'application.",
    "step2_title": "Le livreur accepte",
    "step2_desc": "Un livreur a moto a proximite prend votre demande et se rend au restaurant, street food ou fast food selectionne et vous pouvez suivre son trajet en direct dans l'application.",
    "step3_title": "Payez avec Mobile Money",
    "step3_desc": "Completez votre paiement en toute securite via MTN Mobile Money ou Orange Money.",
    "step4_title": "Livraison rapide",
    "step4_desc": "Votre nourriture arrive chaude et fraiche, livree par un livreur local de confiance qui connait votre quartier."
  },
  "about": {
    "title": "A Propos de Mayouk",
    "subtitle": "Un service concu de la rue, pour tous",
    "description1": "Mayouk represente la chaleur d'une connexion humaine directe, la relation familiere entre les clients et les restaurants et fast food de confiance a Douala et Yaounde.",
    "description2": "Nous sommes nes d'une simple observation : les meilleurs repas sont souvent vendus par le street food, les chop bars, les fast food plutot que par de grands restaurants.",
    "description3": "En exploitant les reseaux de taxis moto qui connaissent deja chaque rue et en utilisant Mobile Money, nous faisons le lien entre les marches locaux traditionnels et la commodite numerique moderne.",
    "mission1_title": "Soutenir les vendeurs locaux",
    "mission1_desc": "Nous donnons au street food la visibilite qu'il merite.",
    "mission2_title": "Autonomiser les livreurs",
    "mission2_desc": "Nous creons des opportunites de livraison pour les chauffeurs de taxis moto.",
    "mission3_title": "Repas locaux authentiques",
    "mission3_desc": "Nous livrons le vrai gout des restaurants et street food camerounais.",
    "mission4_title": "Construire la confiance communautaire",
    "mission4_desc": "Nous favorisons les relations de confiance qui rendent la nourriture locale speciale."
  },
  "vendors": {
    "title": "Pour les restaurants et street food",
    "subtitle": "Developpez votre activite avec Mayouk",
    "benefit1_title": "Visibilite accrue",
    "benefit1_desc": "Atteignez des clients au-dela de votre quartier qui ne savaient pas que vous existiez.",
    "benefit2_title": "Plus de clients",
    "benefit2_desc": "Accedez a un reseau croissant de clients affames a la recherche de nourriture locale authentique.",
    "benefit3_title": "Integration facile",
    "benefit3_desc": "Commencez en quelques minutes avec notre processus d'inscription simple pour les restaurants.",
    "benefit4_title": "Sans frais de demarrage caches",
    "benefit4_desc": "Prix transparents sans frais surprises. Vous gardez ce que vous gagnez.",
    "benefit5_title": "Integration Mobile Money",
    "benefit5_desc": "Recevez les paiements directement sur votre compte MTN Mobile Money ou Orange Money.",
    "cta": "Devenir vendeur"
  },
  "riders": {
    "title": "Pour les livreurs",
    "subtitle": "Gagnez plus avec votre moto",
    "benefit1_title": "Horaires flexibles",
    "benefit1_desc": "Travaillez quand vous le souhaitez. Pas de planning, pas de quotas. Vous etes votre propre patron.",
    "benefit2_title": "Plus d'opportunites",
    "benefit2_desc": "Connectez-vous aux demandes de livraison de nourriture en plus de vos courses de passagers existantes.",
    "benefit3_title": "Revenus supplementaires",
    "benefit3_desc": "Augmentez vos revenus quotidiens avec des demandes de livraison fiables dans votre zone.",
    "benefit4_title": "Inscription facile",
    "benefit4_desc": "Processus d'inscription simple. Commencez a accepter des livraisons en moins de 24 heures.",
    "cta": "Rejoindre le reseau de livreurs"
  },
  "waitlist": {
    "title": "Rejoindre la liste d'attente",
    "subtitle": "Soyez le premier a decouvrir Mayouk lors de notre lancement dans votre ville.",
    "full_name": "Nom complet",
    "phone": "Numero de telephone",
    "neighborhood": "Quartier",
    "status": "Je suis un",
    "status_customer": "Client",
    "status_vendor": "Vendeur",
    "status_rider": "Livreur",
    "submit": "Rejoindre la liste d'attente",
    "success": "Merci ! Vous avez ete ajoute a notre liste d'attente. Nous vous contacterons bientot.",
    "contact_title": "Contactez-nous",
    "phone_label": "Telephone",
    "whatsapp_label": "WhatsApp",
    "email_label": "Email",
    "location_label": "Adresse",
    "phone_value": "+237 681 17 25 45",
    "whatsapp_value": "+237 681 17 25 45",
    "email_value": "info@mayouk.com",
    "location_value": "Akwa, Douala, Cameroun"
  },
  "footer": {
    "about": "A Propos",
    "about_text": "Mayouk connecte les clients, les vendeurs de nourriture locaux et les livreurs a moto a Douala et Yaounde, Cameroun.",
    "navigation": "Navigation",
    "contact": "Contact",
    "social": "Suivez-nous",
    "copyright": "2026 MAYOUK. Tous droits reserves.",
    "tagline": "Concu de la rue, pour tous.",
    "privacy": "Politique de confidentialite",
    "terms": "Conditions d'utilisation"
  },
  "language": {
    "en": "Anglais",
    "fr": "Francais"
  }
};

export default translation;